import React, { useState } from 'react';
import { useEffect } from 'react';
import { getAgeList } from '../utility/utilityFunction';
import MaskedInput from 'react-text-mask';
import { useRef } from 'react';
import Front from '../../assets/images/Front2.svg';
import Left from '../../assets/images/Left.svg';
import Right from '../../assets/images/Right.svg';
import { useSharedDataContext } from '../SharedDataContext';
import Select from 'react-select';

const PetDetailsForm = ({ getPetDetailsObj }) => {

    const [ErrorMSG, setErrorMSG] = useState({});
    const [ageListData, setAgeListData] = useState({});
    const [documentFile, setdocumentFile] = useState(null);

    const [petImages, setPetImages] = useState([
        { label: "front side photo", name: "photoFile3", image: "", imageSrc: "" },
        { label: "left side photo", name: "photoFile", image: "", imageSrc: "" },
        { label: "right side photo", name: "photoFile2", image: "", imageSrc: "" },
    ]);

    const [petDetails, setPetDetails] = useState({
        PetGender: "M",
        PetName: "",
        PetAge: "",
        PetAgeMonth:"",
        PetWeight: "",
        PetIMark: "",
        PetBreed:"",
        IsCommercial: "N",
        CommercialUseDetails: "",
        IsdogInsured: "N",
        OtherInsurerName:"",
        OtherInsurancePolicyNo: "",
        TagNo:""
    });

    const { sharedData, setSharedData } = useSharedDataContext();


    useEffect(() => {
        if (sharedData?.petDetailsObj) {
            setPetDetails(sharedData.petDetailsObj);
            setPetImages(sharedData.petDetailsObj.PetImages);
        } else {
            setPetDetails({ ...petDetails, PetName: sharedData.petname, PetGender:sharedData.petgender =="Male"?"M":"F", PetAge: sharedData.petage, PetAgeMonth: sharedData.petagemonth, PetBreed: sharedData.petbreed,  PetWeight: sharedData.petweight });
        }
    }, []);


    const fileInputRefs = useRef([]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPetDetails(prev=>({ ...prev, [name]: value }));

        if (name === "PetAge" && value?.split(" ")[0] == 0 && petDetails.PetAgeMonth?.split(" ")[0] < 2) {
            setPetDetails(prev => ({ ...prev, PetAgeMonth: "" }));
        } else if (name === "PetAge" && value?.split(" ")[0] == 10) {
            setPetDetails(prev => ({ ...prev, PetAgeMonth: "0 Month" }));
        }

    }

    const handleUploadClick = () => {
        document.getElementById('fileInput').click();
    };
    const handleDocumentFileChange = (event) => {
        const file = event.target.files[0];
        setdocumentFile(file);
    }
    const handlePetImageUpload = (index) => {
        fileInputRefs.current[index].click();
    }

    const handlePhotoFileChange = (e) => {
        const { name, files } = e.target;
        const file = files[0];
        const imgSrc = URL.createObjectURL(file);
        let allImages = petImages.map(row => row.name.toLowerCase() === name.toLowerCase() ? { ...row, image: file, imageSrc: imgSrc } : row);
        //  console.log({ allImages });
        setPetImages(allImages);
    }

    useEffect(() => {
        let monthList = getAgeList(false);
        let yearList = getAgeList(true);
        setAgeListData({ monthList, yearList });
    }, [])

    const submitPetDetailsForm = () => {
        let goto = true;
        let errorMsg = {};
        const { PetGender, PetName, PetAge, PetAgeMonth, PetWeight, PetIMark, IsCommercial, CommercialUseDetails, IsdogInsured, OtherInsurerName, OtherInsurancePolicyNo, PetBreed, TagNo } = petDetails;

        if (!PetGender) {
            errorMsg["PetGender"] = "Please choose pet gender";
            goto = false;
        }
        if (!PetName) {
            errorMsg["PetName"] = "Please choose pet name";
            goto = false;
        }
        if (!PetBreed) {
            errorMsg["PetBreed"] = "Please choose pet breed";
            goto = false;
        }
        if (!PetIMark) {
            errorMsg["PetIMark"] = "Please mention pet identification mark";
            goto = false;
        }
        if (!TagNo && sharedData?.AddonsSelected?.PersonalBelongingsCover && sharedData?.AddonsSelected?.MicroChipOpted) {
            errorMsg["TagNo"] = "Tag No is mandatory when Lost & Stolen Cover is Opted";
            goto = false;
        }
        if (!PetWeight) {
            errorMsg["PetWeight"] = "Please choose pet weight";
            goto = false;
        }
        if (!PetAge) {
            errorMsg["PetAge"] = "Please choose pet age year";
            goto = false;
        } else if (PetAge == "0 Year" && PetAgeMonth == "") {
            errorMsg["PetAgeMonth"] = "Please select age month of your pet";
            goto = false;
        }/*
        if (!PetAgeMonth) {
            errorMsg["PetAgeMonth"] = "Please choose pet age month";
            goto = false;
        }*/
        if (!IsCommercial) {
            errorMsg["IsCommercial"] = "Please choose if the dog is used for commercial purpose or not";
            goto = false;
        }
        if (IsCommercial == "Y" && !CommercialUseDetails) {
            errorMsg["CommercialUseDetails"] = "Please enter the relative information";
            goto = false;
        }
        if (!IsdogInsured) {
            errorMsg["IsdogInsured"] = "Please choose if the dog is insured elsewhere";
            goto = false;
        }
        if (IsdogInsured == "Y" && !OtherInsurancePolicyNo) {
            errorMsg["OtherInsurancePolicyNo"] = "Please enter the other policy number";
            goto = false;
        }
        if (IsdogInsured == "Y" && !OtherInsurerName) {
            errorMsg["OtherInsurerName"] = "Please enter the other insurer name";
            goto = false;
        }
        /* if (!documentFile) {
             ErrorMSG["documentFile"] = "Please upload pet vaccination certificate";
             goto = false;
         }*/
        if (petImages.map(row => !row.image)) {
            petImages.map((obj) => {
                if (!obj.image) {
                    errorMsg[obj.name] = `Please upload ${obj.label}`;
                    goto = false;
                }
            })
        }
        setErrorMSG(errorMsg);

        if (goto) {
            const petDetailsObj = {
                PetGender,
                PetName,
                PetBreed,
                PetIMark: PetIMark ? PetIMark :"None",
                TagNo,
                PetWeight,
                PetAge,
                PetAgeMonth,
                IsCommercial,
                CommercialUseDetails,
                IsdogInsured,
                OtherInsurerName,
                OtherInsurancePolicyNo,
                DocumentFile: documentFile,
                PetImages: petImages
            }
            setSharedData(prev=>({ ...prev, petDetailsObj }));
            getPetDetailsObj(petDetailsObj);
        }
           
    }

    const handleBreedChange = (value) => {
        setPetDetails({ ...petDetails, PetBreed: value });
    }


    return (<>
        <section className="HealthProUpdFormBoxSection">
            <div className="row">
                <div className="col-md-12">
                    <label className="labeltext">Gender</label>
                    <div className="form-check-inline">
                        <label className="HLT_P_T_Box">
                            <input type="radio" name="PetGender" value="M" checked={petDetails.PetGender === "M"} onChange={handleChange} />
                            <span className="checkHLT_P_T_Box"></span>Male
                        </label>
                        <label className="HLT_P_T_Box">
                            <input type="radio" name="PetGender" value="F" checked={petDetails.PetGender === "F"} onChange={handleChange} />
                            <span className="checkHLT_P_T_Box"></span>Female
                        </label>
                    </div>
                    <span className="Error">{ErrorMSG["PetGender"]}</span>
                </div>
            </div>
            <div className="SameForm">
                <div className="row">
                    <div className="col-md-6">
                        <div className="PetInput">
                            <input type="text" placeholder=" " id="ForUppetname" name="PetName" className="InputBox" onChange={handleChange} value={petDetails.PetName} />
                            <label htmlFor="ForUppetname">Pet Name</label>
                            <span className="Error">{ErrorMSG["PetName"]}</span>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="PetInput">
                            {/* <input type="text" placeholder=" " id="ForUppetbreed" className="InputBox" onChange={(e) => setPetBreed(e.target.value)} value={PetBreed} />*/}
                            <Select
                                isDisabled={true}
                                inputId="petBreed"
                                value={petDetails.PetBreed ? { label: petDetails.PetBreed, value: petDetails.PetBreed } : null}
                                options={sharedData?.breedList?.map(breed => ({ label: breed.Breed, value: breed.Breed }))}
                                onChange={(selectedOption) => handleBreedChange(selectedOption.value)}
                                placeholder="Select Pet Breed" className="InputBox liftUpSide"
                            />
                            {/*<label htmlFor="ForUppetbreed">Breed</label>*/}
                            <label htmlFor="petBreed" className="floating_label petBreedLabel">Breed</label>
                            <span className="Error">{ErrorMSG["PetBreed"]}</span>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="PetInput">
                                    <select className="InputBox SpaceInPlaceHolder" disabled value={petDetails.PetAge} name="PetAge" onChange={handleChange}>
                                        <option value="">Select Age</option>
                                        {ageListData?.yearList?.map((age, ind) => < option key={ind}>{age.value}</option>)}
                                    </select>
                                    <label>Select Age (year)</label>
                                    <span className="Error">{ErrorMSG["PetAge"]}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="PetInput">
                                    <select className="InputBox SpaceInPlaceHolder" disabled name="PetAgeMonth"  value={petDetails.PetAgeMonth} onChange={handleChange}>
                                        <option value="">Select Age</option>
                                        {ageListData?.monthList?.map((age, ind) => petDetails.PetAge?.split(" ")[0] == 0 ? (age?.value?.split(" ")[0] > 2) && <option key={ind} value={age.value}>{age.value}</option> : petDetails.PetAge?.split(" ")[0] == 10 ? (age?.value?.split(" ")[0] ==0) && <option key={ind} value={age.value}>{age.value}</option> : <option key={ind} value={age.value}>{age.value}</option>)}
                                    </select>
                                    <label>Select Age (month)</label>
                                    <span className="Error">{ErrorMSG["PetAgeMonth"]}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="PetInput">
                            <MaskedInput type="tel"
                                mask={[/[1-9]/, /\d/]}
                                placeholder=" "
                                showMask={false}
                                guide={false} placeholder=" " id="ForUpweight" disabled  name="PetWeight" className="InputBox" onChange={handleChange} value={petDetails.PetWeight} />
                            <label htmlFor="ForUpweight">Weight</label>
                            {petDetails.PetWeight && <span class="weight_unit">KG</span>}
                            <span className="Error">{ErrorMSG["PetWeight"]}</span>
                        </div>
                    </div>


                    <div className="col-md-6">
                        <div className="PetInput">
                            <input type="text" placeholder=" " id="ForUpPetIMark" className="InputBox" name="PetIMark" onChange={handleChange} value={petDetails.PetIMark} />
                            <label htmlFor="ForUpPetIMark">Identification Mark</label>
                            <small>Type "None" if there are no identification marks</small>
                            <span className="Error">{ErrorMSG["PetIMark"]}</span>
                        </div>
                    </div>

                    {sharedData?.AddonsSelected?.PersonalBelongingsCover && <div className="col-md-6">
                        <div className="PetInput">
                            <input type="text" placeholder=" " id="ForUptagno" className="InputBox" name="TagNo" onChange={handleChange} value={petDetails.TagNo} />
                            <label htmlFor="ForUptagno">Tag Number</label>
                            <span className="Error">{ErrorMSG["TagNo"]}</span>
                        </div>
                    </div>}

                </div>
                <div className="row">
                    <div className="col-md-12">
                        <label className="labeltext">Is the dog's used for commercial purpose?</label>
                    </div>
                    <div className="col-md-6">
                        <div className="form-check-inline">
                            <label className="HLT_P_T_Box me-4 ms-0">
                                <input type="radio" name="IsCommercial" value="Y" checked={petDetails.IsCommercial === "Y"} onChange={handleChange} />
                                <span className="checkHLT_P_T_Box"></span>Yes              
                            </label>                                                       
                            <label className="HLT_P_T_Box me-4 ms-0">                      
                                <input type="radio" name="IsCommercial" value="N" checked={petDetails.IsCommercial === "N"} onChange={handleChange} />
                                <span className="checkHLT_P_T_Box"></span>No
                            </label>
                        </div>
                        <span className="Error">{ErrorMSG["IsCommercial"]}</span>
                    </div>
                </div>
                <div className='col-md-6 mt-3'>
                    {petDetails.IsCommercial === "Y" && (<div className="PetInput">
                        <input type="text" placeholder=" " id="ForUpcommercialdetails" className="InputBox" onChange={handleChange} name="CommercialUseDetails" value={petDetails.CommercialUseDetails} />
                        <label htmlFor="ForUpcommercialdetails">Commercial Use Details</label>
                        <span className="Error">{ErrorMSG["CommercialUseDetails"]}</span>
                    </div>)}
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <label className="labeltext">Is the dog's already insured elsewhere?</label>
                    </div>
                    <div className="col-md-12">
                        <div className="form-check-inline">
                            <label className="HLT_P_T_Box me-4 ms-0">
                                <input type="radio" name="IsdogInsured" value="Y" checked={petDetails.IsdogInsured === "Y"} onChange={handleChange} />
                                <span className="checkHLT_P_T_Box"></span>Yes
                            </label>
                            <label className="HLT_P_T_Box me-4 ms-0">
                                <input type="radio" name="IsdogInsured" value="N" checked={petDetails.IsdogInsured === "N"} onChange={handleChange} />
                                <span className="checkHLT_P_T_Box"></span>No
                            </label>
                        </div>
                        <span className="Error">{ErrorMSG["IsdogInsured"]}</span>
                    </div>
                    {petDetails.IsdogInsured === "Y" && (<>
                        <div className='col-md-6'>
                            <div className="PetInput mt-3">
                                <input type="text" placeholder=" " id="ForUpinsurername" name="OtherInsurerName" className="InputBox" onChange={handleChange} value={petDetails.OtherInsurerName} />
                                <label htmlFor="ForUpinsurername">Insurer Name</label>
                                <span className="Error">{ErrorMSG["OtherInsurerName"]}</span>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="PetInput mt-3">
                                <input type="text" placeholder=" " id="OtherInsurancePolicyNo" name="OtherInsurancePolicyNo" className="InputBox" onChange={handleChange} value={petDetails.OtherInsurancePolicyNo} />
                                <label htmlFor="OtherInsurancePolicyNo">Other Insurance Policy No</label>
                                <span className="Error">{ErrorMSG["OtherInsurancePolicyNo"]}</span>
                            </div>
                        </div></>)}
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <label className="labeltext">Upload Pet Vaccination Certificate</label>
                    </div>
                    <div className="col-md-4">
                        <div class="myLabel" onClick={handleUploadClick}>
                            <input type="file" id="fileInput" accept='.jpeg,.jpg,.png' onChange={handleDocumentFileChange} />
                            <div className="UploadPet">
                                {documentFile ? <img src={documentFile ? URL?.createObjectURL(documentFile) : ""} className="image-fluid" /> :
                                    <i class="fas fa-cloud-upload-alt"></i>}
                            </div>

                            <span className="Error">{ErrorMSG["documentFile"]}</span>
                        </div>
                    </div>
                    <div className="col-md-12 mt-2">
                        <label className="labeltext">Upload Pet Photo</label>
                    </div>
                    <div className="row">

                    </div>
                    {petImages.map((imgObj, ind) => (
                        <>
                            <div className="col-md-3">
                                <div className="myLabel petImgLabel" onClick={() => handlePetImageUpload(ind)}>
                                    <input type="file" accept='.jpeg,.jpg,.png' name={imgObj.name} ref={(el) => (fileInputRefs.current[ind] = el)} onChange={handlePhotoFileChange} />
                                    <div className="UploadPet ">
                                        {/*<i class="fas fa-cloud-upload-alt"></i> <p>{imgObj.label}</p>*/}
                                        {imgObj.imageSrc ? <img src={imgObj.imageSrc} className="petImage img-fluid" />  : <img className="petDemoImg" src={imgObj.label.includes("front") ? Front : imgObj.label.includes("left") ? Left : imgObj.label.includes("right") ? Right : Front} />}
                                    </div>
                                    <span className="">{imgObj.label.includes("front") ? "Front" : imgObj.label.includes("left") ? "Left" : imgObj.label.includes("right") ? "Right" : "Front"}</span> {imgObj.imageSrc && <span className="reuploadText">Re-Upload</span>}
                                    <span className="Error">{ErrorMSG[imgObj.name]}</span>
                                </div>
                            </div>
                        </>
                    ))}
                </div>
            </div>

            <div className="SameForm mt-5">
                <div className="row">
                    <div className="col-md-12 text-center my-2">
                        <button type="submit" onClick={() => submitPetDetailsForm()} className="SMCBTN w-auto" >Save & Continue to Medical History <i className="fas fa-chevron-right"></i></button>
                    </div>
                </div>
            </div>
        </section>
    </>)
}
export default PetDetailsForm;
